class gTagEvents {
    constructor() {
        this.delegateBody = new Delegate(document.body);
        
        this.bindEvents();
        this.observeDOMChanges();
        this.handleIntersects();

        this.interceptCartApi();
    }

    bindEvents() {
        this.delegateBody.on("click", "button[name='checkout']", this.handleCheckout.bind(this));
        this.delegateBody.on("click", '[data-action="ga-send-select"]', this.handleSelectItem.bind(this));
        this.delegateBody.on('variant:changed:gtm', this.handleVariantChange.bind(this));
        this.delegateBody.on("click", '[data-gtm-event="cart_upsell_product_add"]', this.trackCartUpsellAdd.bind(this));
        this.delegateBody.on("click", '[data-gtm-event="homepage_hero_banner_cta"]', this.trackHeroBannerCTA.bind(this));
        this.delegateBody.on("click", '[data-gtm-event="menu_interaction"]', this.trackMenuInteraction.bind(this));
        this.delegateBody.on("click", '[data-gtm-event="product_picture_arrows"]', this.trackProductPictureArrows.bind(this));
        this.delegateBody.on("click", '[data-gtm-event="product_picture_small_images"]', this.trackProductPictureSmallImages.bind(this));
        this.delegateBody.on("click", '[data-gtm-event="product_picture_zoom"]', this.trackProductPictureZoom.bind(this));
        this.delegateBody.on("click", '[data-gtm-event="product_faqs"]', this.trackProductFAQs.bind(this));
        document.addEventListener("DOMContentLoaded", this.setTrackingConsentCookie.bind(this));

        let captureInProgress = false;
    
        document.body.addEventListener("click", (event) => {
            if (captureInProgress) return;
            
            let btn = event.target.hasAttribute?.('data-gtm-button-type') 
                ? event.target 
                : event.target.closest("[data-gtm-button-type]");
            
            if (btn) {
                captureInProgress = true;
                window.__gtmClickedButtonType = btn.dataset.gtmButtonType;
                console.log("Captured button_type:", btn.dataset.gtmButtonType);
                
                // Reset flag after event cycle completes
                setTimeout(() => { captureInProgress = false; }, 0);
            }
        }, true);
            
        }

    observeDOMChanges() {
        const observer = new MutationObserver((mutationsList, observer) => {
            // For each mutation record, we look for added nodes
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length) {
                    // If there are added nodes, we call handleIntersects to check for new items
                    this.handleIntersects();
                }
            }
        });

        // Start observing the document body for added nodes and subtree modifications
        observer.observe(document.body, {
            childList: true, // Observe direct children
            subtree: true, // and all descendants
            attributes: false // Set to true if you also want to observe attribute changes
        });
    }

    handleIntersects() {
        const allIntersections = document.body.querySelectorAll('[data-gtag-intersection][data-observed="false"]');

        allIntersections.forEach((item) => {
            const observer = new IntersectionObserver(
                this.handleIntersection.bind(this),
                {
                    root: null, // Use the viewport as the root
                    rootMargin: "0px",
                    threshold: 0.1, // Adjust the threshold as per your requirement
                }
            );

            observer.observe(item);
            item.dataset.observed = "true";
        });
    }

setTrackingConsentCookie() {
    // Mirrors the visitor's consent into the `_tracking_consent` cookie that the
    // GTM consent variables read (uppercase letter = granted: F, A, M).
    // Rules:
    //  - Never write anything before a visitor who needs the banner has chosen.
    //  - Visitors who need no banner get what Shopify allows (normally granted).
    //  - The listener is always registered, on every page.
    const COOKIE = '_tracking_consent';
    const MIGRATION_FLAG = '_coi_consent_v2';
    const THEME_FORMAT = /^0[fF][aA][mM]\.0$/;

    const readCookie = (name) => {
        const row = document.cookie.split(';').map((c) => c.trim()).find((c) => c.startsWith(name + '='));
        return row ? row.substring(name.length + 1) : null;
    };

    const expiryInOneYear = () => {
        const d = new Date();
        d.setFullYear(d.getFullYear() + 1);
        return d.toUTCString();
    };

    const writeCookie = (functional, analytics, marketing) => {
        const flag = '0' + (functional ? 'F' : 'f') + (analytics ? 'A' : 'a') + (marketing ? 'M' : 'm');
        document.cookie = `${COOKIE}=${flag}.0; path=/; SameSite=Lax; Secure; expires=${expiryInOneYear()}`;
        return flag;
    };

    // Clarity drops consent calls that are queued before it has loaded,
    // so wait until the library is running before confirming consent.
    const confirmClarityConsent = () => {
        let tries = 0;
        const timer = setInterval(() => {
            tries += 1;
            if (window.clarity && window.clarity.v) {
                clearInterval(timer);
                window.clarity('consentv2', { ad_Storage: 'granted', analytics_Storage: 'granted' });
            } else if (tries > 150) {
                clearInterval(timer);
            }
        }, 200);
    };

    // 1. The visitor made a choice in the banner or the preferences dialog.
    document.addEventListener('visitorConsentCollected', (event) => {
        const detail = event.detail;
        if (!detail) return;
        writeCookie(detail.preferencesAllowed, detail.analyticsAllowed, detail.marketingAllowed);
    });

    // 2. One-time cleanup. Older versions of this function wrote "0fam.0" before
    //    any choice was made. While that cookie exists Shopify's consent API loses
    //    its region, so it cannot be trusted on this page view. Remove the cookie
    //    once and evaluate again on the next page view.
    const existing = readCookie(COOKIE);
    if (!readCookie(MIGRATION_FLAG)) {
        document.cookie = `${MIGRATION_FLAG}=1; path=/; SameSite=Lax; Secure; expires=${expiryInOneYear()}`;
        if (existing && THEME_FORMAT.test(existing) && existing === existing.toLowerCase()) {
            document.cookie = `${COOKIE}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
            return;
        }
    }

    // 3. A cookie already exists: keep it. Only the listener above may change it.
    if (existing) return;

    // 4. No cookie yet. Wait for Shopify's consent API, then decide.
    const evaluate = () => {
        const cp = window.Shopify && window.Shopify.customerPrivacy;
        if (!cp || typeof cp.shouldShowBanner !== 'function') return false;
        if (readCookie(COOKIE)) return true;

        // Banner required and no choice yet: write nothing, the banner stays up.
        if (cp.shouldShowBanner()) return true;

        const analytics = cp.analyticsProcessingAllowed();
        const marketing = cp.marketingAllowed();
        writeCookie(cp.preferencesProcessingAllowed(), analytics, marketing);

        // GTM already sent Clarity a "denied" default on this first page view.
        if (analytics && marketing) confirmClarityConsent();
        return true;
    };

    if (evaluate()) return;
    let attempts = 0;
    const waitForApi = setInterval(() => {
        attempts += 1;
        if (evaluate() || attempts > 50) clearInterval(waitForApi);
    }, 200);
}

    handleIntersection(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let data = false;

                try {
                    data = JSON.parse(
                        entry.target.querySelector('script[type="application/ld+json"]').textContent
                    );

                } catch (e) {
                    console.log("JSON parse failed", e);
                }

              if (!dataLayer || !data) return;

                dataLayer.push({ ecommerce: null });
                dataLayer.push(data);

                console.log(data, "And pushed to dataLayer");
            }
        });
    }

    // check if okay
    // how we fetch current variant can vary depending on the theme
    handleVariantChange(event) {        
        // get current variant id from url
        const params = new URLSearchParams(window.location.search);
        const variantIdParam = params.get("variant");
    
        if (!variantIdParam) return;
        const currentVariantID = Number(variantIdParam);
    
        // find current variant json in ShopifyAnalytics
        const variants = ShopifyAnalytics.meta.product.variants;
        let currentVariant = null;
    
        variants.forEach(variant => {        
            if (variant.id === currentVariantID) currentVariant = variant;
        })
    
        // get and update gtm script
        const dataElem = document.querySelector('.main-product__gtm-script');    
        if (!currentVariant || !dataElem) return;
        
        const data = JSON.parse(dataElem.textContent);
        const item = data.ecommerce.items[0];
        
        item.item_variant = currentVariant.public_title || "Default Title";
        item.item_id = currentVariant.id || "";
        item.item_sku = currentVariant.sku || "";
        item.price = currentVariant.price / 100;
        item.quantity = 1;
    
        data.ecommerce.value = currentVariant.price / 100;
    
        if (!dataLayer || !data) return;
    
       dataLayer.push({ ecommerce: null });
       dataLayer.push(data);
        console.log(data, "And pushed to dataLayer");
    }

  interceptCartApi() {
        const originalFetch = window.fetch;
        const _this = this;
    
        window.fetch = async function (...args) {
            let [url, options] = args;
         
            const button_type = window.__gtmClickedButtonType || null;
            window.__gtmClickedButtonType = null;
            // Initialize capturedRequestDataForEvent with button_type
            let capturedRequestDataForEvent = { button_type };
    
            try {
                if (typeof url === 'object' && url !== null) {
                    return originalFetch.apply(this, args);
                }
                if (url && url.includes(`/cart/add.js`) && options && options.body) {
                    if (options.body instanceof FormData) {
                        capturedRequestDataForEvent = {
                            id: options.body.get('id'),
                            quantity: options.body.get('quantity'),
                            category: options.body.get('category'),
                            category2: options.body.get('category2'),
                            button_type: button_type,
                            list_id: options.body.get('list_id'),
                            list_name: options.body.get('list_name'),
                        };
    
                        const category = capturedRequestDataForEvent.category;
                        const category2 = capturedRequestDataForEvent.category2;
                        const list_id = capturedRequestDataForEvent.list_id;
                        const list_name = capturedRequestDataForEvent.list_name;
    
                        if (category) {
                            options.body.append('properties[_category]', category);
                        }
                        if (category2) {
                            options.body.append('properties[_category2]', category2);
                        }
                        if (list_id) {
                            options.body.append('properties[_list_id]', list_id);
                        }
                        if (list_name) {
                            options.body.append('properties[_list_name]', list_name);
                        }
                             if (button_type) {
                            options.body.append('properties[_button_type]', button_type);
                        }
                    } else if (typeof options.body === 'string') {
                         const contentType = options.headers ? (options.headers['Content-Type'] || options.headers['content-type']) : null;
                         if (contentType && contentType.includes('application/json')) {
                            try {
                                let requestPayload = JSON.parse(options.body);
                                capturedRequestDataForEvent = {
                                    id: requestPayload.id,
                                    quantity: requestPayload.quantity,
                                    button_type: button_type, 
                                    category: requestPayload.category,
                                    category2: requestPayload.category2,
                                    list_id: requestPayload.list_id,
                                    list_name: requestPayload.list_name,
                                };
    
                                if (requestPayload && (
                                    capturedRequestDataForEvent.category ||
                                    capturedRequestDataForEvent.category2 ||
                                    capturedRequestDataForEvent.list_id ||
                                    capturedRequestDataForEvent.list_name ||
                                    button_type
                                    )) {
    
                                    requestPayload.properties = requestPayload.properties || {};
                                    if (capturedRequestDataForEvent.category) {
                                        requestPayload.properties['_category'] = capturedRequestDataForEvent.category;
                                    }
                                    if (capturedRequestDataForEvent.category2) {
                                        requestPayload.properties['_category2'] = capturedRequestDataForEvent.category2;
                                    }
                                    if (capturedRequestDataForEvent.list_id) {
                                        requestPayload.properties['_list_id'] = capturedRequestDataForEvent.list_id;
                                    }
                                    if (capturedRequestDataForEvent.list_name) {
                                        requestPayload.properties['_list_name'] = capturedRequestDataForEvent.list_name;
                                    }
                                     if (button_type) {
                                         requestPayload.properties['_button_type'] = button_type;
                                     }
    
                                    options.body = JSON.stringify(requestPayload);
                                    if (options.headers && (options.headers['Content-Length'] || options.headers['content-length'])) {
                                        options.headers['Content-Length'] = new TextEncoder().encode(options.body).length.toString();
                                    }
                                }
                            } catch (e) {
                                console.warn('Fetch interceptor: Failed to parse/modify assumed JSON body for /cart/add.js', e);
                            }
                        }
                    }
                }
    
                if (url && url.includes(`/cart/clear.js`)) _this.cartClear();
    
                const response = await originalFetch.apply(this, args);
                const originalResponse = response;
                const responseClone = response.clone();
    
                if (!responseClone.ok) {
                     console.warn(`Workspace interceptor: Request to ${url} failed with status ${responseClone.status}`);
                    return originalResponse;
                }
    
                 if (
                    url === '' ||
                     typeof dataLayer === 'undefined' ||
                     !(
                         url.includes(`/cart/add.js`) ||
                         url.includes(`/cart/change.js`) ||
                         url.includes(`/cart/update.js`)
                     )
                 ) {
                     return originalResponse;
                 }
    
                let json = null;
                try {
                     json = await responseClone.json();
                } catch (e) {
                    console.error('Fetch interceptor: Failed to parse JSON response from cart API', e, await responseClone.text());
                    return originalResponse;
                }
    
                if (url && url.includes(`/cart/add.js`)) {
                    _this.cartAdd(json, capturedRequestDataForEvent);
                } else if (url && (url.includes(`/cart/change.js`) || url && url.includes(`/cart/update.js`))) {
                    _this.cartUpdate(json);
                }
    
                return originalResponse;
    
            } catch (e) {
                console.error('Fetch interceptor critical error:', e);
                return originalFetch(...args);
            }
        };
    }

    async cartAdd(cart, requestPayload) {
        cart.items ? this.productAdded(cart.items, requestPayload) : this.productAdded([cart], requestPayload);
    }

async cartUpdate(cart) {
    // Don't track quantity changes as "add_to_cart" - only track removals
    
    // Fire remove_from_cart only for completely removed items
    if (cart.items_removed && cart.items_removed.length > 0) {
        const completelyRemoved = [];
        
        for (let i = 0; i < cart.items_removed.length; i++) {
            const removedItem = cart.items_removed[i];
            let stillInCart = false;
            
            for (let j = 0; j < cart.items.length; j++) {
                if (cart.items[j].variant_id === removedItem.variant_id) {
                    stillInCart = true;
                    break;
                }
            }
            
            if (!stillInCart) {
                completelyRemoved.push(removedItem);
            }
        }
        
        if (completelyRemoved.length > 0) {
            this.productsRemoved(completelyRemoved);
        }
    }
}

    async cartClear() {
        const cart = await this.getCart();
        this.productsRemoved(cart.items);
    }

    async getCart() {
        try {
            const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            });

            return await response.json();

        } catch (error) {
            console.log('Fetch Error:', error);
        }
    }

    async productAdded(cartItems, requestPayload) {
        if (!cartItems || !cartItems.length) return;

        const items = [];
        let totalPrice = 0;
    
        // Use a for...of loop to allow awaiting inside the loop
        for (const item of cartItems) {
           
            totalPrice += item.price / 100;

            
            items.push({
                'item_sku': item.sku,
                'item_id': item.sku,
                'id': item.id.toString(),
                'item_name': item.untranslated_product_title,
                'item_brand': item.vendor.replace('®', '').trim(),
                'item_category': requestPayload.category,
                'item_category2': requestPayload.category2,
                'item_list_id': requestPayload.list_id,
                'item_list_name': requestPayload.list_name,
                'item_variant': item.untranslated_variant_title || "Default Title",
                'discount': item.total_discount / 100,
                'price': item.presentment_price,
                'quantity': parseInt(requestPayload.quantity),
                'google_business_vertical': "retail"
            });
        }

        console.log('add_to_cart', items)
    
        const pushData = {
            'event': 'add_to_cart',
            'ecommerce': {
                'value': totalPrice,
                'currency': window.Shopify.currency.active,
                'items': items
            }
        };
        dataLayer.push({ ecommerce: null });
        dataLayer.push(pushData);
         // If sticky button, push additional event
       if (requestPayload?.button_type === 'sticky') {
           const stickyPushData = {
               'event': 'sticky_add_to_cart',
               'ecommerce': {
                   'value': totalPrice,
                   'currency': window.Shopify.currency.active,
                   'items': items
               }
           };
           dataLayer.push({ ecommerce: null });
           dataLayer.push(stickyPushData);
           console.log("dataLayer push -> sticky_add_to_cart:", stickyPushData);
       } else if (requestPayload?.button_type === 'regular') {
           const stickyPushData = {
               'event': 'product_upsell_section_add_to_cart',
               'ecommerce': {
                   'value': totalPrice,
                   'currency': window.Shopify.currency.active,
                   'items': items
               }
           };
           dataLayer.push({ ecommerce: null });
           dataLayer.push(stickyPushData);
           console.log("dataLayer push -> product_upsell_section_add_to_cart:", stickyPushData);
       }
    
    }
    

    async productsRemoved(cartItems) {
        if (!cartItems || !cartItems.length) return;

        const items = [];
        let totalPrice = 0;

        cartItems.forEach(item => {
            const price = Shopify.formatMoney(item.price, '{{amount}}');
            totalPrice += price;

            items.push({
                'item_id': item.sku,
                'item_variant': item.variant_title,
                'item_name': item.product_title,
                'price': price,
                'quantity': parseInt(item.quantity)
            })
        })

        dataLayer.push({
            event: "remove_from_cart",
            remove: {
                value: totalPrice,
                items: items
            },
        });

         console.log("dataLayer push -> remove_from_cart:", items);

    }

    handleCheckout() {
        const button = event.target.closest("button[name='checkout']");
        if (!button) return;

        const script = button.parentElement.querySelector('[type="application/ld+json"]');
        const settings = JSON.parse(script.innerText);

        if (!dataLayer || !settings) return;

        dataLayer.push({ ecommerce: null });
        dataLayer.push(settings);

        console.log("dataLayer push -> checkoutFired:", settings);
    }

    trackCartUpsellAdd(event) {
    const target = event.target.closest('[data-gtm-event="cart_upsell_product_add"]');
    if (!target || typeof dataLayer === 'undefined') return;
    
    const productName = target.dataset.gtmProductName || '';
    
    dataLayer.push({
        event: 'cart_upsell_product_add',
        product_name: productName
    });
    console.log("dataLayer push -> cart_upsell_product_add:", productName);
}

    handleSelectItem(event) {
    let target = event.target.closest('[data-action="ga-send-select"]');
    if (!target || typeof dataLayer === 'undefined') return;

    const settings = JSON.parse(target.dataset.selectSettings);
    if (!settings) return;

    // Use item_id as event name
    const eventName = settings.list_id || 'custom_select_item';

    const customEvent = {
        event: eventName, // Dynamic event name
        ecommerce: {
            selected_item_list_id: settings.list_id,
            selected_item_list_name: settings.list_name,
            currency: ShopifyAnalytics.meta.currency,
            items: [settings]
        }
    }

    dataLayer.push({ ecommerce: null });
    dataLayer.push(customEvent);
    console.log(`dataLayer push -> ${eventName}:`, customEvent);
}

    trackHeroBannerCTA(event) {      
        const target = event.target.closest('[data-gtm-event="homepage_hero_banner_cta"]');
        if (!target || !dataLayer) return;

        const ctaText = target.dataset.gtmCtaText || target.innerText;
        dataLayer.push({
            event: 'homepage_hero_banner_cta',
            cta_text: ctaText,
            cta_url: target.href
        });
        console.log("dataLayer push -> homepage_hero_banner_cta");
    }

    trackMenuInteraction(event) {
        const target = event.target.closest('[data-gtm-event="menu_interaction"]');
        const menuItem = target.dataset.gtmMenuItem || target.innerText;
        console.log(target)
        console.log(menuItem)
        if (!target || !dataLayer) return;

        
        
        dataLayer.push({
            event: 'menu_interaction',
            menu_item: menuItem,
            menu_location: target.dataset.gtmMenuLocation || 'header'
        });
        console.log("dataLayer push -> menu_interaction:", menuItem);
    }

    trackProductPictureArrows(event) {
        if (!dataLayer) return;
        
        const target = event.target.closest('[data-gtm-event="product_picture_arrows"]');
        const direction = target?.dataset.gtmDirection;
        const product = target?.dataset.gtmProduct;
        
        dataLayer.push({
            event: 'product_picture_arrows',
            direction: direction,
            product: product
        });
        console.log("dataLayer push -> product_picture_arrows:", direction);
    }

    trackProductFAQs(event) {
    if (!dataLayer) return;
    
    const target = event.target.closest('[data-gtm-event="product_faqs"]');
    const faqTitle = target?.dataset.gtmFaqTitle || target?.innerText;
    
    dataLayer.push({
        event: 'product_faqs',
        faq_title: faqTitle
    });
    console.log("dataLayer push -> product_faqs:", faqTitle);
    }

    trackProductPictureSmallImages(event) {
        if (!dataLayer) return;
        
        const target = event.target.closest('[data-gtm-event="product_picture_small_images"]');
        const imageIndex = target?.dataset.gtmImageIndex || '0';
        const product = target?.dataset.gtmProduct;
        
        dataLayer.push({
            event: 'product_picture_small_images',
            image_index: imageIndex,
            product: product
        });
        console.log("dataLayer push -> product_picture_small_images:", imageIndex);
    }

    trackProductPictureZoom(event) {
        if (!dataLayer) return;
         const slide = event.target.closest('.swiper-slide');
         const product = slide?.dataset.gtmProduct;
        dataLayer.push({
            event: 'product_picture_zoom',
            product: product
        });
        console.log("dataLayer push -> product_picture_zoom");
    }


    buildEcommerce(cartItems) {
        const items = [];
        let totalPrice = 0;        

        cartItems.forEach((item) => {            
            const price = typeof item.price === "number" ? item.price / 100 : Number(item.price);
            totalPrice += price * item.quantity;
            
            const product = {
                'item_id': item.sku || "",
                'item_name': item.untranslated_product_title || item.title || "",
                'item_variant': item.untranslated_variant_title || "Default Title",
                'price': price, 
                'quantity': item.quantity,
                'category': item.properties?.["_gtm-category"] || "",
                'category2': item.properties?.["_gtm-category2"] || "",
                'item_brand': item.properties?.["_gtm-item_brand"] || "",
                'list_id': item.properties?.["_gtm-list_id"] || "",
                'list_name': item.properties?.["_gtm-list_name"] || ""
            }

            items.push(product);
        });

        return {
            'value': totalPrice,
            'currency': ShopifyAnalytics.meta.currency,
            'items': items
        }
    }

    getDataFromRequest(cartItems, request) {
        const body = request?.body || null;
        if (!body) return cartItems;

        const quantity = body.get("quantity");
        if (quantity) cartItems[0].quantity = Number(quantity);

        return cartItems;
    }
}

new gTagEvents();